/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { defineApis, define } from '@tiny-type-api/universal';
export const { apis } = defineApis({
    '/api/@me': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                },
                404: {
                    body: define()
                }
            }
        }
    },
    '/api/@me/profile': {
        POST: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/@me/actcastDeviceGroups': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/@me/organizations': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/actcastDeviceGroups/:groupId/devices': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/analytics/event/device/:deviceId': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/photo/:deviceId/latest': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/photo/:deviceId/request': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/photo/:deviceId/list': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/deliveryDevice/log': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/notifications': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/system/photo/genderAgeAnalysis': {
        POST: {
            request: {
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/system/notifications': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/system/actcast/webhook': {
        POST: {
            request: {
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    }
});
//# sourceMappingURL=universal.js.map